import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { formatUnitString } from 'utils/formatString';
import { chekIsSpentAcc } from 'utils/accumulators';

import { EmptyButton, HTML } from 'components';
import AccumulatorProgressBar from '../AccumulatorProgressBar';
import AccumulatorInfo from '../AccumulatorInfo';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const AccumulatorBlock = ({
  acc,
  progressBarLimits,
  packages,
  content,
  onClick,
}) => {
  const isSpent = chekIsSpentAcc(acc);
  const additionalPackage = packages.find(({ type }) => type === acc.unit);

  return (
    <EmptyButton className={cx('wrapper')} onClick={onClick}>
      {acc.isUnlimited ? (
        <HTML as="div" className={cx('unlimitedPackageTitle')}>
          {content.unlimitedAccTitles[acc.unit.toLowerCase()]}
        </HTML>
      ) : (
        <AccumulatorInfo acc={acc} />
      )}
      <AccumulatorProgressBar
        className={cx('progressBar')}
        progressBarLimits={progressBarLimits}
        fixedAccSizes={content.fixedAccSizes}
        acc={acc}
      />
      {isSpent && additionalPackage?.baseConditions && (
        <div className={cx('packagePrice')}>
          {additionalPackage.baseConditions}
        </div>
      )}
      {additionalPackage?.connectedAutoProlong && !acc.isUnlimited && (
        <div className={cx('packageRenewal')}>
          <img src="https://static.beeline.ru/upload/images/emoji/circle-arrow-with-point.svg" alt="" />
          {' '}
          {additionalPackage.connectedAutoProlong.value}
          {' '}
          {additionalPackage.connectedAutoProlong.unit}
        </div>
      )}
      {acc.isUnlimited && (
        <div className={cx('packageLock')}>
          <img src="https://static.beeline.ru/upload/images/emoji/flat-lock.svg" alt="" />
          {' '}
          {formatUnitString(acc.rest, acc.unit)}
        </div>
      )}
    </EmptyButton>
  );
};

AccumulatorBlock.propTypes = {
  acc: PropTypes.shape({
    isUnlimited: PropTypes.bool,
    rest: PropTypes.number,
    unit: PropTypes.string,
  }),
  progressBarLimits: PropTypes.object,
  packages: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
  })),
  content: PropTypes.shape({
    unlimitedAccTitles: PropTypes.objectOf(PropTypes.string),
    fixedAccSizes: PropTypes.object,
  }),
  onClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
  progressBarLimits: state.home.accumulators.data.progressBarLimits,
  packages: state.home.tariffServices.data.packages,
});

export default connect(mapStateToProps)(AccumulatorBlock);
